"use client";

import { useFormStatus } from "react-dom";

import { Button } from "@/components/button/button.component";
import { Loader } from "@/components/loader/loader.component";

import { GetProductQueryResult } from "@/sanity.types";

export const ProductActionsCamera = ({
  product,
}: ProductActionsCameraProps) => {
  const { pending } = useFormStatus();
  if (!product?.id || product.type !== "camera") return null;
  return (
    <section
      data-testid="product-actions-camera"
      className="flex flex-col gap-4">
      <div className="flex flex-col gap-4 md:flex-row">
        <input
          id="camera-id"
          type="hidden"
          name="cameraId"
          defaultValue={product.id}
        />
        <Button
          name="action"
          data-testid="product-actions-camera-add-to-cart"
          secondary
          className="flex-1 cursor-pointer"
          type="submit"
          value="add-to-cart"
          disabled={pending}>
          ADD TO CART <Loader loading={pending} size="sm" />
        </Button>
        <Button
          name="action"
          value="build-system"
          data-testid="product-actions-camera-customize"
          secondary
          border
          className="flex-1 cursor-pointer"
          type="submit"
          disabled={pending}>
          Build A System
        </Button>
      </div>
    </section>
  );
};

export type ProductActionsCameraProps = {
  product: GetProductQueryResult;
};
